<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';
import FileIcon from 'next/icon/FileIcon.vue';

const { attachments } = useMessageContext();

const { t } = useI18n();

const url = computed(() => {
  return attachments.value[0].dataUrl;
});

const fileName = computed(() => {
  if (!url.value) return t('CONVERSATION.UNKNOWN_FILE_TYPE');

  try {
    const parsedUrl = new URL(url.value, window.location.origin);
    // Signed S3 URLs carry the original filename in this query param - prefer
    // it over the path segment, which is just the storage blob's random key.
    const disposition = parsedUrl.searchParams.get(
      'response-content-disposition'
    );
    const dispositionMatch = disposition?.match(
      /filename\*?=(?:UTF-8'')?"?([^";]+)"?/
    );
    if (dispositionMatch?.[1]) return dispositionMatch[1];

    const segment = parsedUrl.pathname.split('/').pop();
    return segment
      ? decodeURIComponent(segment)
      : t('CONVERSATION.UNKNOWN_FILE_TYPE');
  } catch (error) {
    const filename = url.value.substring(url.value.lastIndexOf('/') + 1);
    return filename || t('CONVERSATION.UNKNOWN_FILE_TYPE');
  }
});

const fileType = computed(() => {
  return fileName.value.split('.').pop();
});
</script>

<template>
  <BaseAttachmentBubble
    icon="i-teenyicons-user-circle-solid"
    icon-bg-color="bg-n-alpha-3 dark:bg-n-alpha-white"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.FILE"
    :content="fileName"
    :action="{
      href: url,
      label: $t('CONVERSATION.DOWNLOAD'),
    }"
  >
    <template #icon>
      <FileIcon :file-type="fileType" class="size-4" />
    </template>
  </BaseAttachmentBubble>
</template>
